/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CarAttentionItemDto } from '../models';
// @ts-ignore
import type { CarDeadlineDto } from '../models';
// @ts-ignore
import type { CarDeadlinePlanRequestDto } from '../models';
// @ts-ignore
import type { CarDeadlineRequestDto } from '../models';
// @ts-ignore
import type { CarIssueDto } from '../models';
// @ts-ignore
import type { CarIssueRequestDto } from '../models';
// @ts-ignore
import type { CarLogEntryDto } from '../models';
// @ts-ignore
import type { CarLogEntryRequestDto } from '../models';
// @ts-ignore
import type { CreateCarLogEntryRequestDto } from '../models';
/**
 * RestCarMaintenanceApi - axios parameter creator
 */
export const RestCarMaintenanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Czyści zaplanowaną wizytę i anuluje jej zadanie, jeśli jest jeszcze otwarte.
         * @summary Odwołanie zaplanowanej wizyty
         * @param {number} carId 
         * @param {number} carDeadlineTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCarDeadlinePlan: async (carId: number, carDeadlineTypeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('cancelCarDeadlinePlan', 'carId', carId)
            // verify required parameter 'carDeadlineTypeId' is not null or undefined
            assertParamExists('cancelCarDeadlinePlan', 'carDeadlineTypeId', carDeadlineTypeId)
            const localVarPath = `/api/cars/{carId}/deadlines/{carDeadlineTypeId}/plan`
                .replace('{carId}', encodeURIComponent(String(carId)))
                .replace('{carDeadlineTypeId}', encodeURIComponent(String(carDeadlineTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zgłoszenie usterki
         * @param {number} carId 
         * @param {CarIssueRequestDto} carIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarIssue: async (carId: number, carIssueRequestDto: CarIssueRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('createCarIssue', 'carId', carId)
            // verify required parameter 'carIssueRequestDto' is not null or undefined
            assertParamExists('createCarIssue', 'carIssueRequestDto', carIssueRequestDto)
            const localVarPath = `/api/cars/{carId}/issues`
                .replace('{carId}', encodeURIComponent(String(carId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carIssueRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wpis może odnowić termin (nowa data ważności i/lub przebieg; zaplanowana wizyta znika, a jej otwarte zadanie zostaje zakończone) i zamknąć usterkę auta. Przebieg z wpisu podnosi licznik auta, jeśli jest wyższy od zapisanego. 
         * @summary Dodanie wpisu do dziennika
         * @param {number} carId 
         * @param {CreateCarLogEntryRequestDto} createCarLogEntryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarLogEntry: async (carId: number, createCarLogEntryRequestDto: CreateCarLogEntryRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('createCarLogEntry', 'carId', carId)
            // verify required parameter 'createCarLogEntryRequestDto' is not null or undefined
            assertParamExists('createCarLogEntry', 'createCarLogEntryRequestDto', createCarLogEntryRequestDto)
            const localVarPath = `/api/cars/{carId}/log-entries`
                .replace('{carId}', encodeURIComponent(String(carId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCarLogEntryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Usunięcie usterki zgłoszonej omyłkowo
         * @param {number} carId 
         * @param {number} carIssueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarIssue: async (carId: number, carIssueId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('deleteCarIssue', 'carId', carId)
            // verify required parameter 'carIssueId' is not null or undefined
            assertParamExists('deleteCarIssue', 'carIssueId', carIssueId)
            const localVarPath = `/api/cars/{carId}/issues/{carIssueId}`
                .replace('{carId}', encodeURIComponent(String(carId)))
                .replace('{carIssueId}', encodeURIComponent(String(carIssueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Odnowionego terminu nie cofa; usterka zamknięta tym wpisem zostaje zamknięta.
         * @summary Usunięcie wpisu z dziennika
         * @param {number} carId 
         * @param {number} carLogEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarLogEntry: async (carId: number, carLogEntryId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('deleteCarLogEntry', 'carId', carId)
            // verify required parameter 'carLogEntryId' is not null or undefined
            assertParamExists('deleteCarLogEntry', 'carLogEntryId', carLogEntryId)
            const localVarPath = `/api/cars/{carId}/log-entries/{carLogEntryId}`
                .replace('{carId}', encodeURIComponent(String(carId)))
                .replace('{carLogEntryId}', encodeURIComponent(String(carLogEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Jeden termin na każdy aktywny typ terminu ze słownika CAR_DEADLINE_TYPE, także taki, którego jeszcze nikt nie uzupełnił (stan MISSING), ze stanem policzonym na dziś. 
         * @summary Terminy auta
         * @param {number} carId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarDeadlines: async (carId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('getCarDeadlines', 'carId', carId)
            const localVarPath = `/api/cars/{carId}/deadlines`
                .replace('{carId}', encodeURIComponent(String(carId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Najpierw otwarte (unieruchamiające na początku), potem naprawione od najnowszej.
         * @summary Usterki auta
         * @param {number} carId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarIssues: async (carId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('getCarIssues', 'carId', carId)
            const localVarPath = `/api/cars/{carId}/issues`
                .replace('{carId}', encodeURIComponent(String(carId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wpisy od najnowszego.
         * @summary Dziennik napraw i serwisu auta
         * @param {number} carId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarLogEntries: async (carId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('getCarLogEntries', 'carId', carId)
            const localVarPath = `/api/cars/{carId}/log-entries`
                .replace('{carId}', encodeURIComponent(String(carId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wszystkie sprawy aktywnych aut, które ktoś musi załatwić: termin po czasie, termin wkrótce bez zaplanowanej wizyty, minięta data zaplanowanej wizyty bez wpisu w dzienniku, brak daty terminu oraz otwarte usterki. Najpierw najpilniejsze. Każda pozycja niesie opiekuna auta, żeby front mógł pokazać licznik tylko jego autom. 
         * @summary Sprawy aut wymagające uwagi
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarsAttention: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cars/attention`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zapisuje datę wizyty i zakłada zadanie przypięte do auta dla wskazanej osoby z tą datą jako terminem. Wcześniejsze zadanie tego terminu, jeśli jest otwarte, zostaje anulowane. 
         * @summary Zaplanowanie wizyty dla terminu
         * @param {number} carId 
         * @param {number} carDeadlineTypeId 
         * @param {CarDeadlinePlanRequestDto} carDeadlinePlanRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        planCarDeadline: async (carId: number, carDeadlineTypeId: number, carDeadlinePlanRequestDto: CarDeadlinePlanRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('planCarDeadline', 'carId', carId)
            // verify required parameter 'carDeadlineTypeId' is not null or undefined
            assertParamExists('planCarDeadline', 'carDeadlineTypeId', carDeadlineTypeId)
            // verify required parameter 'carDeadlinePlanRequestDto' is not null or undefined
            assertParamExists('planCarDeadline', 'carDeadlinePlanRequestDto', carDeadlinePlanRequestDto)
            const localVarPath = `/api/cars/{carId}/deadlines/{carDeadlineTypeId}/plan`
                .replace('{carId}', encodeURIComponent(String(carId)))
                .replace('{carDeadlineTypeId}', encodeURIComponent(String(carDeadlineTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carDeadlinePlanRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ustawia datę ważności i/lub przebieg, przy którym termin wypada, albo oznacza, że termin auta nie dotyczy. Zaplanowana wizyta zostaje bez zmian. 
         * @summary Uzupełnienie terminu auta
         * @param {number} carId 
         * @param {number} carDeadlineTypeId 
         * @param {CarDeadlineRequestDto} carDeadlineRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarDeadline: async (carId: number, carDeadlineTypeId: number, carDeadlineRequestDto: CarDeadlineRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('updateCarDeadline', 'carId', carId)
            // verify required parameter 'carDeadlineTypeId' is not null or undefined
            assertParamExists('updateCarDeadline', 'carDeadlineTypeId', carDeadlineTypeId)
            // verify required parameter 'carDeadlineRequestDto' is not null or undefined
            assertParamExists('updateCarDeadline', 'carDeadlineRequestDto', carDeadlineRequestDto)
            const localVarPath = `/api/cars/{carId}/deadlines/{carDeadlineTypeId}`
                .replace('{carId}', encodeURIComponent(String(carId)))
                .replace('{carDeadlineTypeId}', encodeURIComponent(String(carDeadlineTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carDeadlineRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zmiana opisu lub wagi usterki
         * @param {number} carId 
         * @param {number} carIssueId 
         * @param {CarIssueRequestDto} carIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarIssue: async (carId: number, carIssueId: number, carIssueRequestDto: CarIssueRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('updateCarIssue', 'carId', carId)
            // verify required parameter 'carIssueId' is not null or undefined
            assertParamExists('updateCarIssue', 'carIssueId', carIssueId)
            // verify required parameter 'carIssueRequestDto' is not null or undefined
            assertParamExists('updateCarIssue', 'carIssueRequestDto', carIssueRequestDto)
            const localVarPath = `/api/cars/{carId}/issues/{carIssueId}`
                .replace('{carId}', encodeURIComponent(String(carId)))
                .replace('{carIssueId}', encodeURIComponent(String(carIssueId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carIssueRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zmienia tylko treść wpisu; odnowionego terminu i zamkniętej usterki nie cofa.
         * @summary Zmiana wpisu w dzienniku
         * @param {number} carId 
         * @param {number} carLogEntryId 
         * @param {CarLogEntryRequestDto} carLogEntryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarLogEntry: async (carId: number, carLogEntryId: number, carLogEntryRequestDto: CarLogEntryRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carId' is not null or undefined
            assertParamExists('updateCarLogEntry', 'carId', carId)
            // verify required parameter 'carLogEntryId' is not null or undefined
            assertParamExists('updateCarLogEntry', 'carLogEntryId', carLogEntryId)
            // verify required parameter 'carLogEntryRequestDto' is not null or undefined
            assertParamExists('updateCarLogEntry', 'carLogEntryRequestDto', carLogEntryRequestDto)
            const localVarPath = `/api/cars/{carId}/log-entries/{carLogEntryId}`
                .replace('{carId}', encodeURIComponent(String(carId)))
                .replace('{carLogEntryId}', encodeURIComponent(String(carLogEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(carLogEntryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestCarMaintenanceApi - functional programming interface
 */
export const RestCarMaintenanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestCarMaintenanceApiAxiosParamCreator(configuration)
    return {
        /**
         * Czyści zaplanowaną wizytę i anuluje jej zadanie, jeśli jest jeszcze otwarte.
         * @summary Odwołanie zaplanowanej wizyty
         * @param {number} carId 
         * @param {number} carDeadlineTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelCarDeadlinePlan(carId: number, carDeadlineTypeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelCarDeadlinePlan(carId, carDeadlineTypeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarMaintenanceApi.cancelCarDeadlinePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Zgłoszenie usterki
         * @param {number} carId 
         * @param {CarIssueRequestDto} carIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCarIssue(carId: number, carIssueRequestDto: CarIssueRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarIssueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCarIssue(carId, carIssueRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarMaintenanceApi.createCarIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Wpis może odnowić termin (nowa data ważności i/lub przebieg; zaplanowana wizyta znika, a jej otwarte zadanie zostaje zakończone) i zamknąć usterkę auta. Przebieg z wpisu podnosi licznik auta, jeśli jest wyższy od zapisanego. 
         * @summary Dodanie wpisu do dziennika
         * @param {number} carId 
         * @param {CreateCarLogEntryRequestDto} createCarLogEntryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCarLogEntry(carId: number, createCarLogEntryRequestDto: CreateCarLogEntryRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarLogEntryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCarLogEntry(carId, createCarLogEntryRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarMaintenanceApi.createCarLogEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Usunięcie usterki zgłoszonej omyłkowo
         * @param {number} carId 
         * @param {number} carIssueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCarIssue(carId: number, carIssueId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCarIssue(carId, carIssueId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarMaintenanceApi.deleteCarIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Odnowionego terminu nie cofa; usterka zamknięta tym wpisem zostaje zamknięta.
         * @summary Usunięcie wpisu z dziennika
         * @param {number} carId 
         * @param {number} carLogEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCarLogEntry(carId: number, carLogEntryId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCarLogEntry(carId, carLogEntryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarMaintenanceApi.deleteCarLogEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Jeden termin na każdy aktywny typ terminu ze słownika CAR_DEADLINE_TYPE, także taki, którego jeszcze nikt nie uzupełnił (stan MISSING), ze stanem policzonym na dziś. 
         * @summary Terminy auta
         * @param {number} carId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarDeadlines(carId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarDeadlineDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCarDeadlines(carId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarMaintenanceApi.getCarDeadlines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Najpierw otwarte (unieruchamiające na początku), potem naprawione od najnowszej.
         * @summary Usterki auta
         * @param {number} carId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarIssues(carId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarIssueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCarIssues(carId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarMaintenanceApi.getCarIssues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Wpisy od najnowszego.
         * @summary Dziennik napraw i serwisu auta
         * @param {number} carId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarLogEntries(carId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarLogEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCarLogEntries(carId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarMaintenanceApi.getCarLogEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Wszystkie sprawy aktywnych aut, które ktoś musi załatwić: termin po czasie, termin wkrótce bez zaplanowanej wizyty, minięta data zaplanowanej wizyty bez wpisu w dzienniku, brak daty terminu oraz otwarte usterki. Najpierw najpilniejsze. Każda pozycja niesie opiekuna auta, żeby front mógł pokazać licznik tylko jego autom. 
         * @summary Sprawy aut wymagające uwagi
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarsAttention(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarAttentionItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCarsAttention(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarMaintenanceApi.getCarsAttention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zapisuje datę wizyty i zakłada zadanie przypięte do auta dla wskazanej osoby z tą datą jako terminem. Wcześniejsze zadanie tego terminu, jeśli jest otwarte, zostaje anulowane. 
         * @summary Zaplanowanie wizyty dla terminu
         * @param {number} carId 
         * @param {number} carDeadlineTypeId 
         * @param {CarDeadlinePlanRequestDto} carDeadlinePlanRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async planCarDeadline(carId: number, carDeadlineTypeId: number, carDeadlinePlanRequestDto: CarDeadlinePlanRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.planCarDeadline(carId, carDeadlineTypeId, carDeadlinePlanRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarMaintenanceApi.planCarDeadline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ustawia datę ważności i/lub przebieg, przy którym termin wypada, albo oznacza, że termin auta nie dotyczy. Zaplanowana wizyta zostaje bez zmian. 
         * @summary Uzupełnienie terminu auta
         * @param {number} carId 
         * @param {number} carDeadlineTypeId 
         * @param {CarDeadlineRequestDto} carDeadlineRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCarDeadline(carId: number, carDeadlineTypeId: number, carDeadlineRequestDto: CarDeadlineRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCarDeadline(carId, carDeadlineTypeId, carDeadlineRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarMaintenanceApi.updateCarDeadline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Zmiana opisu lub wagi usterki
         * @param {number} carId 
         * @param {number} carIssueId 
         * @param {CarIssueRequestDto} carIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCarIssue(carId: number, carIssueId: number, carIssueRequestDto: CarIssueRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCarIssue(carId, carIssueId, carIssueRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarMaintenanceApi.updateCarIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zmienia tylko treść wpisu; odnowionego terminu i zamkniętej usterki nie cofa.
         * @summary Zmiana wpisu w dzienniku
         * @param {number} carId 
         * @param {number} carLogEntryId 
         * @param {CarLogEntryRequestDto} carLogEntryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCarLogEntry(carId: number, carLogEntryId: number, carLogEntryRequestDto: CarLogEntryRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCarLogEntry(carId, carLogEntryId, carLogEntryRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCarMaintenanceApi.updateCarLogEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestCarMaintenanceApi - factory interface
 */
export const RestCarMaintenanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestCarMaintenanceApiFp(configuration)
    return {
        /**
         * Czyści zaplanowaną wizytę i anuluje jej zadanie, jeśli jest jeszcze otwarte.
         * @summary Odwołanie zaplanowanej wizyty
         * @param {number} carId 
         * @param {number} carDeadlineTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelCarDeadlinePlan(carId: number, carDeadlineTypeId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelCarDeadlinePlan(carId, carDeadlineTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zgłoszenie usterki
         * @param {number} carId 
         * @param {CarIssueRequestDto} carIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarIssue(carId: number, carIssueRequestDto: CarIssueRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CarIssueDto> {
            return localVarFp.createCarIssue(carId, carIssueRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Wpis może odnowić termin (nowa data ważności i/lub przebieg; zaplanowana wizyta znika, a jej otwarte zadanie zostaje zakończone) i zamknąć usterkę auta. Przebieg z wpisu podnosi licznik auta, jeśli jest wyższy od zapisanego. 
         * @summary Dodanie wpisu do dziennika
         * @param {number} carId 
         * @param {CreateCarLogEntryRequestDto} createCarLogEntryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCarLogEntry(carId: number, createCarLogEntryRequestDto: CreateCarLogEntryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CarLogEntryDto> {
            return localVarFp.createCarLogEntry(carId, createCarLogEntryRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Usunięcie usterki zgłoszonej omyłkowo
         * @param {number} carId 
         * @param {number} carIssueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarIssue(carId: number, carIssueId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCarIssue(carId, carIssueId, options).then((request) => request(axios, basePath));
        },
        /**
         * Odnowionego terminu nie cofa; usterka zamknięta tym wpisem zostaje zamknięta.
         * @summary Usunięcie wpisu z dziennika
         * @param {number} carId 
         * @param {number} carLogEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCarLogEntry(carId: number, carLogEntryId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCarLogEntry(carId, carLogEntryId, options).then((request) => request(axios, basePath));
        },
        /**
         * Jeden termin na każdy aktywny typ terminu ze słownika CAR_DEADLINE_TYPE, także taki, którego jeszcze nikt nie uzupełnił (stan MISSING), ze stanem policzonym na dziś. 
         * @summary Terminy auta
         * @param {number} carId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarDeadlines(carId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<CarDeadlineDto>> {
            return localVarFp.getCarDeadlines(carId, options).then((request) => request(axios, basePath));
        },
        /**
         * Najpierw otwarte (unieruchamiające na początku), potem naprawione od najnowszej.
         * @summary Usterki auta
         * @param {number} carId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarIssues(carId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<CarIssueDto>> {
            return localVarFp.getCarIssues(carId, options).then((request) => request(axios, basePath));
        },
        /**
         * Wpisy od najnowszego.
         * @summary Dziennik napraw i serwisu auta
         * @param {number} carId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarLogEntries(carId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<CarLogEntryDto>> {
            return localVarFp.getCarLogEntries(carId, options).then((request) => request(axios, basePath));
        },
        /**
         * Wszystkie sprawy aktywnych aut, które ktoś musi załatwić: termin po czasie, termin wkrótce bez zaplanowanej wizyty, minięta data zaplanowanej wizyty bez wpisu w dzienniku, brak daty terminu oraz otwarte usterki. Najpierw najpilniejsze. Każda pozycja niesie opiekuna auta, żeby front mógł pokazać licznik tylko jego autom. 
         * @summary Sprawy aut wymagające uwagi
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarsAttention(options?: RawAxiosRequestConfig): AxiosPromise<Array<CarAttentionItemDto>> {
            return localVarFp.getCarsAttention(options).then((request) => request(axios, basePath));
        },
        /**
         * Zapisuje datę wizyty i zakłada zadanie przypięte do auta dla wskazanej osoby z tą datą jako terminem. Wcześniejsze zadanie tego terminu, jeśli jest otwarte, zostaje anulowane. 
         * @summary Zaplanowanie wizyty dla terminu
         * @param {number} carId 
         * @param {number} carDeadlineTypeId 
         * @param {CarDeadlinePlanRequestDto} carDeadlinePlanRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        planCarDeadline(carId: number, carDeadlineTypeId: number, carDeadlinePlanRequestDto: CarDeadlinePlanRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.planCarDeadline(carId, carDeadlineTypeId, carDeadlinePlanRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Ustawia datę ważności i/lub przebieg, przy którym termin wypada, albo oznacza, że termin auta nie dotyczy. Zaplanowana wizyta zostaje bez zmian. 
         * @summary Uzupełnienie terminu auta
         * @param {number} carId 
         * @param {number} carDeadlineTypeId 
         * @param {CarDeadlineRequestDto} carDeadlineRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarDeadline(carId: number, carDeadlineTypeId: number, carDeadlineRequestDto: CarDeadlineRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCarDeadline(carId, carDeadlineTypeId, carDeadlineRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zmiana opisu lub wagi usterki
         * @param {number} carId 
         * @param {number} carIssueId 
         * @param {CarIssueRequestDto} carIssueRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarIssue(carId: number, carIssueId: number, carIssueRequestDto: CarIssueRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCarIssue(carId, carIssueId, carIssueRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Zmienia tylko treść wpisu; odnowionego terminu i zamkniętej usterki nie cofa.
         * @summary Zmiana wpisu w dzienniku
         * @param {number} carId 
         * @param {number} carLogEntryId 
         * @param {CarLogEntryRequestDto} carLogEntryRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCarLogEntry(carId: number, carLogEntryId: number, carLogEntryRequestDto: CarLogEntryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCarLogEntry(carId, carLogEntryId, carLogEntryRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestCarMaintenanceApi - interface
 */
export interface RestCarMaintenanceApiInterface {
    /**
     * Czyści zaplanowaną wizytę i anuluje jej zadanie, jeśli jest jeszcze otwarte.
     * @summary Odwołanie zaplanowanej wizyty
     * @param {number} carId 
     * @param {number} carDeadlineTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelCarDeadlinePlan(carId: number, carDeadlineTypeId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Zgłoszenie usterki
     * @param {number} carId 
     * @param {CarIssueRequestDto} carIssueRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCarIssue(carId: number, carIssueRequestDto: CarIssueRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CarIssueDto>;

    /**
     * Wpis może odnowić termin (nowa data ważności i/lub przebieg; zaplanowana wizyta znika, a jej otwarte zadanie zostaje zakończone) i zamknąć usterkę auta. Przebieg z wpisu podnosi licznik auta, jeśli jest wyższy od zapisanego. 
     * @summary Dodanie wpisu do dziennika
     * @param {number} carId 
     * @param {CreateCarLogEntryRequestDto} createCarLogEntryRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCarLogEntry(carId: number, createCarLogEntryRequestDto: CreateCarLogEntryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CarLogEntryDto>;

    /**
     * 
     * @summary Usunięcie usterki zgłoszonej omyłkowo
     * @param {number} carId 
     * @param {number} carIssueId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCarIssue(carId: number, carIssueId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Odnowionego terminu nie cofa; usterka zamknięta tym wpisem zostaje zamknięta.
     * @summary Usunięcie wpisu z dziennika
     * @param {number} carId 
     * @param {number} carLogEntryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCarLogEntry(carId: number, carLogEntryId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Jeden termin na każdy aktywny typ terminu ze słownika CAR_DEADLINE_TYPE, także taki, którego jeszcze nikt nie uzupełnił (stan MISSING), ze stanem policzonym na dziś. 
     * @summary Terminy auta
     * @param {number} carId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCarDeadlines(carId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<CarDeadlineDto>>;

    /**
     * Najpierw otwarte (unieruchamiające na początku), potem naprawione od najnowszej.
     * @summary Usterki auta
     * @param {number} carId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCarIssues(carId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<CarIssueDto>>;

    /**
     * Wpisy od najnowszego.
     * @summary Dziennik napraw i serwisu auta
     * @param {number} carId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCarLogEntries(carId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<CarLogEntryDto>>;

    /**
     * Wszystkie sprawy aktywnych aut, które ktoś musi załatwić: termin po czasie, termin wkrótce bez zaplanowanej wizyty, minięta data zaplanowanej wizyty bez wpisu w dzienniku, brak daty terminu oraz otwarte usterki. Najpierw najpilniejsze. Każda pozycja niesie opiekuna auta, żeby front mógł pokazać licznik tylko jego autom. 
     * @summary Sprawy aut wymagające uwagi
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCarsAttention(options?: RawAxiosRequestConfig): AxiosPromise<Array<CarAttentionItemDto>>;

    /**
     * Zapisuje datę wizyty i zakłada zadanie przypięte do auta dla wskazanej osoby z tą datą jako terminem. Wcześniejsze zadanie tego terminu, jeśli jest otwarte, zostaje anulowane. 
     * @summary Zaplanowanie wizyty dla terminu
     * @param {number} carId 
     * @param {number} carDeadlineTypeId 
     * @param {CarDeadlinePlanRequestDto} carDeadlinePlanRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planCarDeadline(carId: number, carDeadlineTypeId: number, carDeadlinePlanRequestDto: CarDeadlinePlanRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Ustawia datę ważności i/lub przebieg, przy którym termin wypada, albo oznacza, że termin auta nie dotyczy. Zaplanowana wizyta zostaje bez zmian. 
     * @summary Uzupełnienie terminu auta
     * @param {number} carId 
     * @param {number} carDeadlineTypeId 
     * @param {CarDeadlineRequestDto} carDeadlineRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCarDeadline(carId: number, carDeadlineTypeId: number, carDeadlineRequestDto: CarDeadlineRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Zmiana opisu lub wagi usterki
     * @param {number} carId 
     * @param {number} carIssueId 
     * @param {CarIssueRequestDto} carIssueRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCarIssue(carId: number, carIssueId: number, carIssueRequestDto: CarIssueRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Zmienia tylko treść wpisu; odnowionego terminu i zamkniętej usterki nie cofa.
     * @summary Zmiana wpisu w dzienniku
     * @param {number} carId 
     * @param {number} carLogEntryId 
     * @param {CarLogEntryRequestDto} carLogEntryRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCarLogEntry(carId: number, carLogEntryId: number, carLogEntryRequestDto: CarLogEntryRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestCarMaintenanceApi - object-oriented interface
 */
export class RestCarMaintenanceApi extends BaseAPI implements RestCarMaintenanceApiInterface {
    /**
     * Czyści zaplanowaną wizytę i anuluje jej zadanie, jeśli jest jeszcze otwarte.
     * @summary Odwołanie zaplanowanej wizyty
     * @param {number} carId 
     * @param {number} carDeadlineTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelCarDeadlinePlan(carId: number, carDeadlineTypeId: number, options?: RawAxiosRequestConfig) {
        return RestCarMaintenanceApiFp(this.configuration).cancelCarDeadlinePlan(carId, carDeadlineTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zgłoszenie usterki
     * @param {number} carId 
     * @param {CarIssueRequestDto} carIssueRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCarIssue(carId: number, carIssueRequestDto: CarIssueRequestDto, options?: RawAxiosRequestConfig) {
        return RestCarMaintenanceApiFp(this.configuration).createCarIssue(carId, carIssueRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Wpis może odnowić termin (nowa data ważności i/lub przebieg; zaplanowana wizyta znika, a jej otwarte zadanie zostaje zakończone) i zamknąć usterkę auta. Przebieg z wpisu podnosi licznik auta, jeśli jest wyższy od zapisanego. 
     * @summary Dodanie wpisu do dziennika
     * @param {number} carId 
     * @param {CreateCarLogEntryRequestDto} createCarLogEntryRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCarLogEntry(carId: number, createCarLogEntryRequestDto: CreateCarLogEntryRequestDto, options?: RawAxiosRequestConfig) {
        return RestCarMaintenanceApiFp(this.configuration).createCarLogEntry(carId, createCarLogEntryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Usunięcie usterki zgłoszonej omyłkowo
     * @param {number} carId 
     * @param {number} carIssueId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCarIssue(carId: number, carIssueId: number, options?: RawAxiosRequestConfig) {
        return RestCarMaintenanceApiFp(this.configuration).deleteCarIssue(carId, carIssueId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Odnowionego terminu nie cofa; usterka zamknięta tym wpisem zostaje zamknięta.
     * @summary Usunięcie wpisu z dziennika
     * @param {number} carId 
     * @param {number} carLogEntryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCarLogEntry(carId: number, carLogEntryId: number, options?: RawAxiosRequestConfig) {
        return RestCarMaintenanceApiFp(this.configuration).deleteCarLogEntry(carId, carLogEntryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Jeden termin na każdy aktywny typ terminu ze słownika CAR_DEADLINE_TYPE, także taki, którego jeszcze nikt nie uzupełnił (stan MISSING), ze stanem policzonym na dziś. 
     * @summary Terminy auta
     * @param {number} carId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCarDeadlines(carId: number, options?: RawAxiosRequestConfig) {
        return RestCarMaintenanceApiFp(this.configuration).getCarDeadlines(carId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Najpierw otwarte (unieruchamiające na początku), potem naprawione od najnowszej.
     * @summary Usterki auta
     * @param {number} carId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCarIssues(carId: number, options?: RawAxiosRequestConfig) {
        return RestCarMaintenanceApiFp(this.configuration).getCarIssues(carId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Wpisy od najnowszego.
     * @summary Dziennik napraw i serwisu auta
     * @param {number} carId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCarLogEntries(carId: number, options?: RawAxiosRequestConfig) {
        return RestCarMaintenanceApiFp(this.configuration).getCarLogEntries(carId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Wszystkie sprawy aktywnych aut, które ktoś musi załatwić: termin po czasie, termin wkrótce bez zaplanowanej wizyty, minięta data zaplanowanej wizyty bez wpisu w dzienniku, brak daty terminu oraz otwarte usterki. Najpierw najpilniejsze. Każda pozycja niesie opiekuna auta, żeby front mógł pokazać licznik tylko jego autom. 
     * @summary Sprawy aut wymagające uwagi
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCarsAttention(options?: RawAxiosRequestConfig) {
        return RestCarMaintenanceApiFp(this.configuration).getCarsAttention(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zapisuje datę wizyty i zakłada zadanie przypięte do auta dla wskazanej osoby z tą datą jako terminem. Wcześniejsze zadanie tego terminu, jeśli jest otwarte, zostaje anulowane. 
     * @summary Zaplanowanie wizyty dla terminu
     * @param {number} carId 
     * @param {number} carDeadlineTypeId 
     * @param {CarDeadlinePlanRequestDto} carDeadlinePlanRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public planCarDeadline(carId: number, carDeadlineTypeId: number, carDeadlinePlanRequestDto: CarDeadlinePlanRequestDto, options?: RawAxiosRequestConfig) {
        return RestCarMaintenanceApiFp(this.configuration).planCarDeadline(carId, carDeadlineTypeId, carDeadlinePlanRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ustawia datę ważności i/lub przebieg, przy którym termin wypada, albo oznacza, że termin auta nie dotyczy. Zaplanowana wizyta zostaje bez zmian. 
     * @summary Uzupełnienie terminu auta
     * @param {number} carId 
     * @param {number} carDeadlineTypeId 
     * @param {CarDeadlineRequestDto} carDeadlineRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCarDeadline(carId: number, carDeadlineTypeId: number, carDeadlineRequestDto: CarDeadlineRequestDto, options?: RawAxiosRequestConfig) {
        return RestCarMaintenanceApiFp(this.configuration).updateCarDeadline(carId, carDeadlineTypeId, carDeadlineRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zmiana opisu lub wagi usterki
     * @param {number} carId 
     * @param {number} carIssueId 
     * @param {CarIssueRequestDto} carIssueRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCarIssue(carId: number, carIssueId: number, carIssueRequestDto: CarIssueRequestDto, options?: RawAxiosRequestConfig) {
        return RestCarMaintenanceApiFp(this.configuration).updateCarIssue(carId, carIssueId, carIssueRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zmienia tylko treść wpisu; odnowionego terminu i zamkniętej usterki nie cofa.
     * @summary Zmiana wpisu w dzienniku
     * @param {number} carId 
     * @param {number} carLogEntryId 
     * @param {CarLogEntryRequestDto} carLogEntryRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCarLogEntry(carId: number, carLogEntryId: number, carLogEntryRequestDto: CarLogEntryRequestDto, options?: RawAxiosRequestConfig) {
        return RestCarMaintenanceApiFp(this.configuration).updateCarLogEntry(carId, carLogEntryId, carLogEntryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

